<template>
	<div class="">
		<ModalBox v-model="legacyModalVisible" :size="modalSize" hide-close header-class="!hidden" wrapper-classes="lg:h-auto lg:max-h-none p-6">

		<div class="flex flex-wrap">
			<div class="w-full">Change FPS</div>
		</div>
		<div class="flex flex-wrap">
			<div class="text-s-s text-dark-8 w-full">Default FPS for transcoding is 30 FPS. If you're streaming at 60 FPS, you can change it here.</div>
		</div>
        <div class="ml-1 mt-4 flex flex-wrap">
            <div class="mb-2">
                <FormRadio v-model="selectedFps" name="selected-fps" inputValue="30" label="30fps" />
                <FormRadio v-model="selectedFps" name="selected-fps" inputValue="60" label="60fps" />
            </div>
        </div>
		<div class="flex flex-wrap" >
			<div class="text-right mt-3 w-full">
				<FormButton
					type="secondary"
					@click="dismiss"
					class="mr-2"
					size="md"
				>
					Cancel
				</FormButton>
				<FormButton
					type="main"
                    :disabled="(Number(fps) === Number(selectedFps))"
					size="md"
					@click="onSave"
				>
                    Save Changes
				</FormButton>
			</div>
		</div>
		
</ModalBox>
	</div>
</template>

<script>
import ModalBox from '@/components/modals/ModalBox.vue'
import { legacyModalBridgeMixin } from '@/composables/useLegacyModalBridge'
import FormRadio from '@/components/Atoms/FormRadio.vue'
import FormButton from '@/components/Atoms/FormButton.vue'
export default {
	name: 'StreamAbrSettingsModal',
	mixins: [legacyModalBridgeMixin],
	components: {
		ModalBox, FormRadio, FormButton },
	props: {
		modalId: {
			type: String,
			default: 'StreamAbrSettingsModal'
		},
		modalSize: {
			type: String,
			default: 'sm',
			validator(v) {
				return ['xl', 'lg', 'md', 'sm'].some(size => size === v);
			}
		},
        fps: {
            type: Number,
            default: 30
        },
        stream: {
            type: Object,
			required: true
        },
	},
	data() {
		return {
			processing: false,
            selectedFps: this.fps
		};
	},
	methods: {
		onSave() {
			this.$emit('abr-fps-changed', this.selectedFps);
			this.dismiss();
		},
		dismiss() {
			this.hideLegacyModal();
			// lazy clear
			setTimeout(() => { this.processing = false; }, 1000);
		}
	},
};
</script>

<style scoped>

</style>
